import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

import type { DraggableBounds } from 'react-draggable';

export const useSymbolDragBounds = (anchor: RefObject<HTMLElement | null>) => {
  const [dragging, setDragging] = useState(false);
  const [dragBounds, setDragBounds] = useState<false | DraggableBounds>(false);
  useEffect(() => {
    const updateBounds = () => {
      if (anchor.current) {
        const boxRect = anchor.current.getBoundingClientRect();
        const width = boxRect.width;
        const height = boxRect.height;

        setDragBounds({
          left: 0,
          top: 0,
          right: window.innerWidth - width,
          bottom: window.innerHeight - height
        });
      }
    };

    updateBounds();
    window.addEventListener('resize', updateBounds);
    return () => {
      window.removeEventListener('resize', updateBounds);
    };
  }, [dragging, anchor]);

  return {
    dragBounds,
    dragging,
    setDragging
  };
};
